export default function firstCapital(str) {
    if (str && str !== null) {
        return str.toLowerCase().replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();})
    }
    return "";
}
